import React, {useState, forwardRef, useImperativeHandle} from 'react';
import PropTypes from 'prop-types';
import {Button, Form, Input, message, Modal} from 'antd';

import {SendOutlined} from '@/icons';
import {replyComment} from '@/api/comment';

const ReplyCommentForm = forwardRef(({reload}, ref) => {
    const [visible, setVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [content, setContent] = useState(null);
    const [commentId, setCommentId] = useState(null);

    function showModal(commentId) {
        setVisible(true);
        setCommentId(commentId);
    }

    function closeModal(confirm = true) {
        if (confirm && content) {
            Modal.confirm({
                title: '警告',
                content: '确定放弃已编辑内容？',
                onOk: () => {
                    resetOnClose();
                },
            });
        } else {
            resetOnClose();
        }
    }

    function resetOnClose() {
        setVisible(false);
        setLoading(false);
        setContent(null);
    }

    useImperativeHandle(ref, () => ({
        showModal,
        closeModal,
    }));

    function onContentChange(e) {
        setContent(e.target.value);
    }

    function onSendClick() {
        setLoading(true);
        replyComment(commentId, content)
            .then(data => {
                console.log(data);
                reload && reload();
                closeModal(false);
            })
            .catch(e => {
                message.error(e.message);
            })
            .finally(() => {
                setLoading(false);
            });
    }

    return (
        <>
            <Modal
                destroyOnClose
                maskClosable={false}
                title="回复留言"
                visible={visible}
                onCancel={closeModal}
                footer={null}
            >
                <Form.Item>
                    <Input.TextArea
                        allowClear
                        rows={4}
                        autoFocus
                        maxLength={3000}
                        value={content}
                        onChange={onContentChange}
                    />
                </Form.Item>
                <Button
                    type="primary"
                    icon={<SendOutlined />}
                    disabled={!content || !content.trim()}
                    loading={loading}
                    onClick={onSendClick}
                >
                    发送
                </Button>
            </Modal>
        </>
    );
});

ReplyCommentForm.displayName = 'ReplyCommentForm';

ReplyCommentForm.propTypes = {
    reload: PropTypes.func,
};

export default ReplyCommentForm;
